import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import AssignmentForm from '../components/AssignmentForm'
import {
  actionCreators,
  IAssignmentFormState,
  selectAssignment,
  selectIsSaving,
} from '../modules/assignmentForm'

export default connect(
  createStructuredSelector<ApplicationState, IAssignmentFormState>({
    assignment: selectAssignment(),
    isSaving: selectIsSaving(),
  }),
  actionCreators,
)(AssignmentForm)
